/**
 * @param {{
 *   ProductTagServiceV2: ReturnType<import('../../../services/v2/ProductTagServiceV2').default>,
 * }} param0
 */
export default function productTagUseCaseV2({ ProductTagServiceV2 }) {
  const list = (params) => ProductTagServiceV2.list(params);

  const getBySlug = (slug) => {
    if (!slug) {
      throw new Error('Missing slug');
    }
    return ProductTagServiceV2.getBySlug(slug);
  };

  const getDetail = (slug) => {
    if (!slug) {
      throw new Error('Missing slug');
    }
    return ProductTagServiceV2.getDetail(slug);
  };

  const create = ({ slug }) => {
    if (!slug) {
      throw new Error('Missing slug');
    }
    return ProductTagServiceV2.create({ slug });
  };

  const update = ({ id, slug }) => {
    if (!id) {
      throw new Error('Missing id');
    }
    if (!slug) {
      throw new Error('Missing slug');
    }
    return ProductTagServiceV2.update({ id, slug });
  };

  const remove = (id) => {
    if (!id) {
      throw new Error('Missing id');
    }
    return ProductTagServiceV2.remove(id);
  };

  return {
    list,
    getBySlug,
    getDetail,
    create,
    update,
    remove,
  };
}
